/**
 * ChatDashboardWidget - Widget clicável para filtrar atendimentos
 */

import React from 'react';
import { Icon } from '@/shared/icons'
import type { IconName } from '@/shared/icons';

export interface ChatDashboardWidgetProps {
  title: string;
  value: number;
  icon: IconName;
  color: 'primary' | 'warning' | 'success' | 'error' | 'info';
  onClick?: () => void;
  isActive?: boolean;
}

const colorStyles = {
  primary: {
    bg: 'rgba(139, 92, 246, 0.1)',
    icon: '#8b5cf6',
    activeBg: 'rgba(139, 92, 246, 0.2)',
  },
  warning: {
    bg: 'rgba(251, 191, 36, 0.1)',
    icon: '#fbbf24',
    activeBg: 'rgba(251, 191, 36, 0.2)',
  },
  success: {
    bg: 'rgba(52, 211, 153, 0.1)',
    icon: '#34d399',
    activeBg: 'rgba(52, 211, 153, 0.2)',
  },
  error: {
    bg: 'rgba(248, 113, 113, 0.1)',
    icon: '#f87171',
    activeBg: 'rgba(248, 113, 113, 0.2)',
  },
  info: {
    bg: 'rgba(96, 165, 250, 0.1)',
    icon: '#60a5fa',
    activeBg: 'rgba(96, 165, 250, 0.2)',
  },
};

export const ChatDashboardWidget: React.FC<ChatDashboardWidgetProps> = ({
  title,
  value,
  icon,
  color,
  onClick,
  isActive = false,
}) => {
  const colors = colorStyles[color];

  return (
    <button
      onClick={onClick}
      className="p-4 rounded-lg border transition-all cursor-pointer text-left w-full"
      style={{
        backgroundColor: isActive ? colors.activeBg : 'var(--theme-card-background)',
        borderColor: isActive ? colors.icon : 'var(--theme-card-border)',
        borderWidth: isActive ? '2px' : '1px',
      }}
      onMouseEnter={(e) => {
        if (!isActive) {
          e.currentTarget.style.backgroundColor = colors.bg;
        }
      }}
      onMouseLeave={(e) => {
        if (!isActive) {
          e.currentTarget.style.backgroundColor = 'var(--theme-card-background)';
        }
      }}
    >
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm mb-1" style={{ color: 'var(--theme-muted-text)' }}>
            {title}
          </p>
          <p className="text-2xl font-bold" style={{ color: 'var(--theme-card-text)' }}>
            {value}
          </p>
        </div>
        <div
          className="p-3 rounded-lg"
          style={{ backgroundColor: colors.bg }}
        >
          <Icon name={icon} className="w-6 h-6" style={{ color: colors.icon }} />
        </div>
      </div>
    </button>
  );
};
